
import { type PropType, defineComponent } from "vue";
import {
  VIcon as VuetifyIcon,
  VListItem as VuetifyListItem,
  VListItemContent as VuetifyListItemContent,
  VListItemIcon as VuetifyListItemIcon,
  VSelect as VuetifySelect,
} from "vuetify/lib";

export default defineComponent({
  components: { VuetifyIcon, VuetifyListItem, VuetifyListItemContent, VuetifyListItemIcon, VuetifySelect },
  mixins: [VuetifySelect],
  props: {
    color: {
      type: String,
      default: "grey-80",
    },
    dense: {
      type: Boolean,
      default: true,
    },
    hideDetails: {
      type: Boolean,
      default: true,
    },
    menuProps: {
      type: [String, Object] as PropType<string | Record<string, unknown>>,
      default: () => ({
        bottom: true,
        contentClass: "elevation-large border-menu",
        maxHeight: 255,
        nudgeBottom: 16,
        offsetY: true,
        rounded: true,
      }),
    },
    outlined: {
      type: Boolean,
      default: true,
    },
  },
});
